module.exports = __webpack_public_path__ + "img/icon_linkedin_white.27da083.svg";